import { useLocation, useNavigate } from 'react-router-dom';
import { Accordion, Button, Card, Icon, Message, Typography } from '@uigovpe/components';
import { PageHeader } from '@/shared/components/PageHeader';

const FAQ = [
  {
    header: 'O que é a certidão de ocorrência?',
    content: (
      <Typography variant="p" size="default">
        É o documento oficial em que o Corpo de Bombeiros Militar de Pernambuco
        atesta um atendimento que realizou — incêndio, vazamento de gás,
        salvamento, entre outros. Costuma ser exigida por seguradoras,
        condomínios e órgãos públicos.
      </Typography>
    ),
  },
  {
    header: 'Quanto tempo leva?',
    content: (
      <Typography variant="p" size="default">
        Depois do envio, a equipe do Corpo de Bombeiros analisa o pedido e entra
        em contato pelos dados que você informou. Você recebe um e-mail a cada
        mudança de situação e pode acompanhar tudo em Minhas Solicitações.
      </Typography>
    ),
  },
  {
    header: 'Preciso saber o número da ocorrência?',
    content: (
      <Typography variant="p" size="default">
        Não. Informe a natureza do fato, a data e o horário aproximados e, se
        lembrar, o endereço. Esses dados já permitem que a equipe localize o
        atendimento.
      </Typography>
    ),
  },
];

export function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const authRequired = Boolean(
    (location.state as { authRequired?: boolean } | null)?.authRequired,
  );

  return (
    <>
      <PageHeader
        eyebrow="Certidão Digital"
        title="Certidão de ocorrência do Corpo de Bombeiros"
        description="Solicite pela internet a certidão de um atendimento realizado pelo CBMPE e acompanhe o andamento pelo portal."
      />

      {authRequired && (
        <Message
          severity="warn"
          text="Entre com sua conta gov.br para solicitar, acompanhar ou editar seu perfil."
        />
      )}

      <div className="cd-services">
        <Card className="cd-service">
          <Typography variant="h3" fontWeight="bold">
            Solicitar certidão
          </Typography>
          <Typography variant="p" size="sm">
            Informe os dados da ocorrência e envie o pedido em quatro etapas.
          </Typography>
          <Button
            label="Começar"
            icon="pi pi-arrow-right"
            iconPos="right"
            onClick={() => navigate('/request')}
          />
        </Card>

        <Card className="cd-service">
          <Typography variant="h3" fontWeight="bold">
            Minhas solicitações
          </Typography>
          <Typography variant="p" size="sm">
            Acompanhe o andamento e retome rascunhos que você deixou pela metade.
          </Typography>
          <Button
            label="Acompanhar"
            outlined
            icon="pi pi-list"
            onClick={() => navigate('/my-requests')}
          />
        </Card>
      </div>

      <Message
        severity="info"
        text="A emissão da certidão é concluída pela equipe do Corpo de Bombeiros, que entra em contato com você pelos dados informados na solicitação."
      />

      <section className="cd-faq">
        <Typography variant="h2" size="lg" fontWeight="bold">
          Dúvidas frequentes
        </Typography>
        <Accordion items={FAQ} />
      </section>
    </>
  );
}
